// React imports.
import React, { Component } from "react";

// App imports.


const StartNewAssessment = ({ state }) => (
    <div>
        <p><strong>CHOOSING AN ASSESMENT:</strong></p>
        <p>This is the screen from which you can start a new assessment.</p>
        <p>
            <strong>Before you begin</strong> an assessment, you will need to click the corresponding
            &nbsp;<strong>Before You Begin</strong> button for that assessment in the table below
            to download a PDF of the data items you will need. These
            PDFs can be given directly to your database programmers
            so that they can pull the data you will need to complete
            the assessment.
        </p>
        <p>
            <strong>One you have all of the necessary data</strong> you can click on
            the <strong>Start Assessment</strong> button to begin working through
            the assessment.
        </p>
        <p>
            <strong>Important Note:</strong> The Overall Reliability Assessment is designed to
            conduct a preliminary screening of your data and alert you to where your data look
            reliable and where you might want to dig deeper into potential issues using one
            of the assessments. Therefore, you should always complete the Overall Reliability
            Assessment first whenever you are beginning to use the tool for a program year
            that you have not analyzed before.  
        </p>

        <strong>Select an Assessment:</strong>
        <br/><br/>
        <table data-bind="visible:savedAssessments().length>0">
              <thead>
                  <tr>
                      <th>Assessment #</th>
                      <th>Assessment Name</th>
                      <th>Action</th>
                  </tr>
              </thead>
              <tbody>
        
                  <tr>
                      <td >Overall</td>
                      <td >Overall Reliability Assessment</td>
                      <td >
                          <a href="/data_warehouse/doc/EBOA.pdf" target="_blank">Before You Begin</a><br />
                          <a href='#' onClick={() => state.startNewAssessementAssessmentSelected('oa')}>Begin Assessment</a>
                      </td>
                  </tr> 

                  <tr>
                      <td >1</td>
                      <td >Defining Data Requirements</td>
                      <td >
                          <a href="/data_warehouse/doc/EBA1.pdf" target="_blank">Before You Begin</a> <br />
                          <a href='#' onClick={() => state.startNewAssessementAssessmentSelected('1')}>Begin Assessment</a>
                      </td>
                  </tr> 
                  <tr>
                      <td >2A</td>
                      <td >Data Collection – Vendors</td>
                      <td >
                          <a href="/data_warehouse/doc/EBA2A.pdf" target="_blank">Before You Begin</a> <br />
                          <a href='#' onClick={() => state.startNewAssessementAssessmentSelected('2a')}>Begin Assessment</a>
                      </td>
                  </tr>
                  <tr>
                      <td >2B</td>
                      <td >Data Collection – Households</td>
                      <td >
                          <a href="/data_warehouse/doc/EBA2B.pdf" target="_blank">Before You Begin</a> <br />
                          <a href='#' onClick={() => state.startNewAssessementAssessmentSelected('2b')}>Begin Assessment</a>
                      </td>
                  </tr> 
                  <tr>
                      <td >3A</td>
                      <td >Data Recording & Processing – Vendor Assignment</td>
                      <td >
                          <a href="/data_warehouse/doc/EBA3A.pdf" target="_blank">Before You Begin</a><br />
                          <a href='#' onClick={() => state.startNewAssessementAssessmentSelected('3a')}>Begin Assessment</a>
                           
                      </td>
                  </tr>
                  <tr>
                      <td >3B</td>
                      <td >Data Recording &amp; Processing – Account Matching</td>
                      <td >
                          <a href="/data_warehouse/doc/EBA3B.pdf" target="_blank">Before You Begin</a><br />
                          <a href='#' onClick={() => state.startNewAssessementAssessmentSelected('3b')}>Begin Assessment</a>
                      </td>
                  </tr> 
                  <tr>
                      <td >4</td>
                      <td >Data Checking Routines</td>
                      <td >
                          <a href="/data_warehouse/doc/EBA4.pdf" target="_blank">Before You Begin</a><br />
                          <a href='#' onClick={() => state.startNewAssessementAssessmentSelected('4')}>Begin Assessment</a>
                      </td>
                  </tr> 
                                
              </tbody>    
        </table>
        <br/>
        <button className="dataButton" onClick={() => state.startStartNewAssessementPageBack()}
            >Back</button>

    </div>
);

export default StartNewAssessment;
